// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../../../assets/chevron-left-solid.svg");
var ___CSS_LOADER_URL_IMPORT_1___ = require("../../../assets/chevron-right-solid.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
// Module
exports.push([module.id, "[data-v-a3e6bc4e] .datepicker header .prev{content:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ")!important}[data-v-a3e6bc4e] .datepicker header .next,[data-v-a3e6bc4e] .datepicker header .prev{margin-top:12px;margin-bottom:12px;width:28px;margin-right:8px;height:16px}[data-v-a3e6bc4e] .datepicker header .next{content:url(" + ___CSS_LOADER_URL_REPLACEMENT_1___ + ")!important}", ""]);
// Exports
module.exports = exports;
